import { cn } from '../../utils';
import { ActivityWidget } from './ActivityWidget';
import type { NotificationView } from './types';

const VARIANT_CLASS = {
  // Floating pill (single item + top of the stack).
  card: 'rounded-full bg-background-input px-md py-sm shadow-lg',
  // Lighter row inside the expanded dropdown panel.
  row: 'rounded-lg px-sm py-sm'
} as const;

const INTERACTIVE_CLASS = 'transition-colors hover:bg-background-muted';

export interface ActivityCardProps {
  activity: NotificationView;
  seedKey?: string;
  variant?: keyof typeof VARIANT_CLASS;
  /** Host navigates to the underlying document/invoice. Omit for a static, non-clickable pill. */
  onOpen?: (activity: NotificationView) => void;
  className?: string;
}

/** A notification row — clickable when `onOpen` is given, a plain status pill otherwise. */
export function ActivityCard({
  activity,
  seedKey,
  variant = 'card',
  onOpen,
  className
}: ActivityCardProps) {
  const widget = <ActivityWidget activity={activity} seedKey={seedKey} />;
  const baseClass = cn('block w-full text-left', VARIANT_CLASS[variant], className);

  if (!onOpen) {
    return <div className={baseClass}>{widget}</div>;
  }

  return (
    <button
      type='button'
      onClick={() => onOpen(activity)}
      className={cn(baseClass, INTERACTIVE_CLASS)}
    >
      {widget}
    </button>
  );
}
